import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/Context';
import { FaChevronLeft } from 'react-icons/fa';
import { useState } from 'react';
import { RiDeleteBin2Fill } from 'react-icons/ri';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import Loader from '../../components/Loader/Loader';
import 'react-loading-skeleton/dist/skeleton.css';
import { AddClub, DeleteClubs } from '../../components/Modals/Modals';

const Clubs = () => {
  const navigate = useNavigate();
  const { showProfileModal, baseURL } = useGlobalContext();
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = JSON.parse(sessionStorage.getItem(`adminData`));
  const [showAddClubModal, setShowAddClubModal] = useState(false);
  const [showDeleteClubsModal, setShowDeleteClubsModal] = useState(false);

  const fetchClubs = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${baseURL}/clubs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      setClubs(data.clubs);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClubs();
    // eslint-disable-next-line
  }, [showAddClubModal, showDeleteClubsModal]);

  const deleteClub = async (clubId) => {
    try {
      const { data } = await axios.delete(`${baseURL}/clubs/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(data.msg);
      fetchClubs();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <main className='clubs-page'>
      <Navbar category={`Management >`} currentPage={`Clubs`} />
      <Sidebar activePage={10} />

      <div className={`main-content ${showProfileModal ? `back` : null}`}>
        <div className='title-btn'>
          <FaChevronLeft onClick={() => navigate(`/dashboard`)} />
          <h2 className='title'>Clubs</h2>
        </div>

        {loading ? (
          <Loader />
        ) : (
          <>
            <div className='add-delete-club'>
              <button
                className='primary'
                onClick={() => setShowAddClubModal(true)}
              >
                Add Club
              </button>
              <button
                className='red'
                onClick={() => setShowDeleteClubsModal(true)}
              >
                Delete Clubs
              </button>
            </div>

            <section className='available-clubs'>
              <h2>Available Clubs</h2>

              {clubs.length > 0 ? (
                <div className='grid'>
                  {clubs.map((club) => {
                    const { _id, clubName, clubLogo } = club;
                    return (
                      <div className='item' key={_id}>
                        <div className='img'>
                          <img
                            src={`https://api.crspredictions.com${clubLogo}`}
                            alt={clubName}
                          />
                        </div>
                        <p className='name'>{clubName}</p>
                        <RiDeleteBin2Fill
                          className='del'
                          onClick={() => deleteClub(_id)}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className='no-club'>
                  <h1>No clubs yet</h1>
                </div>
              )}
            </section>
          </>
        )}
      </div>
      {showAddClubModal && <AddClub dismissFunc={setShowAddClubModal} />}
      {showDeleteClubsModal && (
        <DeleteClubs dismissFunc={setShowDeleteClubsModal} />
      )}
    </main>
  );
};

export default Clubs;
